import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PortalService } from '../../../../../services/portal.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-upload-missing-document',
  templateUrl: './upload-missing-document.component.html',
  styleUrl: './upload-missing-document.component.scss'
})
export class UploadMissingDocumentComponent {
  selectedFiles: {
    file: File;
    preview: string;
    description: string;
    name: string;
    type: string;
    attachmentId?: number;
  }[] = [];
  isFileUploading: boolean = false;
  enrollmentId : any;
  manufacturerId = environment.manufacturerID;
  constructor(
    private portalService: PortalService,
    public dialogRef: MatDialogRef<UploadMissingDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
     this.enrollmentId = this.data.enrollmentId;
  }

  onFilesSelected(event: any): void {
    const files: FileList = event.target.files;

    if (files.length > 0) {
      const file = files[0]; 

      // Check for duplicate file
      if (this.selectedFiles.some((selected) => selected.file.name === file.name)) {
        console.warn(`File "${file.name}" is already selected.`);
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const description = `AdditionalInformation`;
        console.log(`Adding file: ${file.name}, Description: ${description}`);

        // Add file to selectedFiles array
        this.selectedFiles.push({
          file,
          preview: e.target.result,
          name: file.name,
          type: file.type.startsWith('image') ? 'image' : 'pdf',
          description,
        });

        console.log('Updated selectedFiles array:', this.selectedFiles);

        const fileInput = document.getElementById('fileUpload') as HTMLInputElement;
        if (fileInput) {
          fileInput.disabled = true;
        }

        //this.uploadFile(file, description);
      };
      reader.readAsDataURL(file);
    }
  }

  upload(): void {
    if (this.selectedFiles.length === 0) {
      console.warn('No files selected for upload.');
      return;
    }
 
    this.isFileUploading = true;
 
    this.selectedFiles.forEach((selectedFile) => {
      const formData = new FormData();
      formData.append('EnrollmentId', this.enrollmentId.toString());
      formData.append('ManufacturerId', this.manufacturerId.toString());
      formData.append('EnrollmentAttachmentDocumentDTOs[0].EnrollmentAttchmentTypeId','12');
      formData.append('EnrollmentAttachmentDocumentDTOs[0].Description',selectedFile.description);
      formData.append('EnrollmentAttachmentDocumentDTOs[0].FileDocument', selectedFile.file,selectedFile.name
      );
 
      this.portalService.missingDocumentAttachment(formData).subscribe(
        (response) => {
          if (Array.isArray(response) && response.length > 0) {
            const documentAttachmentId = response[0].id;
            selectedFile.attachmentId = documentAttachmentId;
          }
        },
        (error) => {
          console.error('Error uploading file:', error);
        },
        () => {
          this.isFileUploading = false;
          this.close(true);
          console.log('File upload complete.');
        }
      );
    });
  }

  uploadFile(file: File, description: string): void {
    const formData = new FormData();
    formData.append('EnrollmentId', this.enrollmentId.toString());
    formData.append('ManufacturerId', this.manufacturerId.toString());
    formData.append('EnrollmentAttachmentDocumentDTOs[0].EnrollmentAttchmentTypeId', '12');
    formData.append('EnrollmentAttachmentDocumentDTOs[0].Description', description);
    formData.append('EnrollmentAttachmentDocumentDTOs[0].FileDocument', file, file.name);

    this.isFileUploading = true;

    this.portalService.missingDocumentAttachment(formData).subscribe(
      (response) => {
        if (Array.isArray(response) && response.length > 0) {
          const documentAttachmentId = response[0].id;
          const uploadedFile = this.selectedFiles.find((f) => f.description === description);
          if (uploadedFile) {
            uploadedFile.attachmentId = documentAttachmentId;
            //this.cdr.detectChanges();
          }
        }
        this.isFileUploading = false;
      },
      (error) => {
        console.error('Error uploading file:', error);
        this.isFileUploading = false;
      }
    );


  }

  removeFile(index: number): void {
    const fileToRemove = this.selectedFiles[index];
    this.selectedFiles.splice(index, 1);

    // Re-enable the file input
    const fileInput = document.getElementById('fileUpload') as HTMLInputElement;
    if (fileInput) {
      fileInput.disabled = false;
      fileInput.value = '';
    }

    if (!fileToRemove.attachmentId) {
      console.error('Attachment ID not found for the file:', fileToRemove);
      return;
    }

    this.portalService.removeDocumentAttachment(fileToRemove.attachmentId).subscribe(
      (response) => {
        console.log('Document removed successfully:', response);

        // Trigger change detection
        // this.cdr.detectChanges();

        // Reset upload container if no files remain
        if (this.selectedFiles.length === 0) {
          console.log('No files left. Resetting upload container.');
        }
      },
      (error) => {
        console.error('Error removing document:', error);
      }
    );
  }
  close(isRefreshNeeded = false): void {
    this.dialogRef.close(isRefreshNeeded);
  }

}
